import { useState, useEffect } from "react";

const pad = number => number.toString().padStart(2, "0");

export function calculateTimeLeft(time) {
  if (!time) return null;

  const difference = +new Date(time) - +new Date();
  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: pad(Math.floor(difference / (1000 * 60 * 60 * 24))),
      hours: pad(Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))),
      minutes: pad(Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))),
      seconds: pad(Math.floor((difference % (1000 * 60)) / 1000))
    };

    return timeLeft;
  }
}

export function useCountdownTimer(time) {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(time));
    }, 1000);

    return () => clearTimeout(timer);
  });

  return timeLeft;
}
